import { type ReactNode } from 'react';

function CardHeader({
  icon,
  title,
  subtitle,
}: {
  icon: ReactNode;
  title: string;
  subtitle: string;
}): ReactNode {
  return (
    <div className="mb-lg flex items-center gap-md">
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white/[0.04] text-text-tertiary">
        {icon}
      </span>
      <div>
        <h3 className="text-sm font-medium text-text-primary">{title}</h3>
        <p className="text-[11px] leading-relaxed text-text-tertiary">
          {subtitle}
        </p>
      </div>
    </div>
  );
}

export function SettingsCard({
  icon,
  title,
  subtitle,
  children,
}: {
  icon: ReactNode;
  title: string;
  subtitle: string;
  children: ReactNode;
}): ReactNode {
  return (
    <div className="rounded-xl bg-surface p-lg">
      <CardHeader icon={icon} title={title} subtitle={subtitle} />
      <div className="grid grid-cols-1 gap-x-lg gap-y-lg sm:grid-cols-2 lg:grid-cols-3">
        {children}
      </div>
    </div>
  );
}
